<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <div class="meinmenu_title">
            <div>RASHIKUのご紹介</div>
            <div>はじめてのお客様へ</div>
          </div>
          <section>
            <div id="start_ms">
              <!-- <div>
                <img :src="getImage('common/noimage.png')" style="width:20rem;">
                <div>RASHIKU運営企業</div>
                <div>ドゥーマンズ株式会社</div>
                <div>代表 二宮 健一</div>
              </div> -->
              <p>
                規格サイズの収納家具を検討されてる皆様！一度お待ちください！<br>
                <br>
                私たちRASHIKUは、従来の規格サイズの収納家具では解決できない、<span class="pickup">お部屋の間取りやスタイルに合わせた収納家具を全国配送にて販売する専門サイトです。</span>
                収納でお困りのお客様にご満足いただけるよう、豊富なデザインから選択いただいた家具を、<span class="pickup">1mm単位でサイズ調整</span>でき、<span class="pickup">カラーも自由</span>にお選びいただけます。<br>
                <br>
                吊戸棚（フロート収納）からテレビボード、食器棚（カップボード）など、お部屋のあらゆる収納をとり揃えており、<br>
                『既製品では不満だけど、フルオーダーは高くて ・・・ 』<br>
                『内装・建具の色柄と合う収納が欲しい』<br>
                『壁から壁までのジャストフィットの収納が欲しい』<br>
                という皆様のお困りごとを、RASHIKUが全て解決したします！<br>
                <br>
                収納家具選びで迷われている皆様、まずはご相談ください。
              </p>
            </div>
            <div v-if="!isHaseko">
              <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
            </div>
          </section>
          <section id="what_mmstyle">
            <h2>1ミリ単位のサイズオーダー × お部屋のスタイルに合わせたデザイン</h2>
            <div class="procedure_with_img">
              <div>
                <img :src="getImage('about/01_design.webp')">
              </div>
              <div>
                <p>
                  RASHIKUでは、収納家具を1mm単位でサイズ オーダーが可能、お部屋に合わせた無駄のない収納家具をご購入いただけます。<br>
                  規格サイズの家具と異なり、お部屋に収納家具がジャストフィットし、すっきりと納まった見た目になります。<br>
                  また、お部屋のスタイルに合わせて、さまざまなデザインの収納家具からお選びいたただくことができます。
                </p>
              </div>
            </div>
          </section>
          <section id="low_price">
            <h2>高品質なのに、低価格な理由</h2>
            <p>
              ドゥーマンズは、お客様が本当の意味で住心地を改善いただけるよう、RASHIKUをご活用いただければ、と考えております。<br>
              高品質なオーダー家具を低価格でお客様にご提供させていただく仕組みをご案内させてください。<br>
              ・商品を製造工場からお客様の元へ直送させていただくことで、低価格を実現しております。<br>
              ・従来のオーダー家具は、設計や製造に非常に手間と時間がかかります。<br>
                RASHIKUは独自の特許取得済みのシステムにより、この手間と時間をなくすことで、低価格を実現しております。
            </p>
            <section>
              <h3><span>1.</span>国内工場からお客様の元まで直送</h3>
              <p>
                通常、お客様の元に家具が届くまでには、たくさんの会社が関わっています。商品を企画するメーカー、製造する工場、製造品を流通させる商社、
                お客様に販売する小売店。お客様が購入する商品の価格は、それぞれの会社の利益が上乗せされた価格です。<br>
                RASHIKUでは、工場が商品を企画・製造し、お客様の元へ直接お届けします。関係する会社が少ない分、価格が安くなるという仕組みです。<br>
                また、長く日本国内の最高品質基準を達成してきた工場のみが、RASHIKUに商品を掲載しています。自信を持って良い商品をお届けいたしますので、ご安心ください。
              </p>
              <img :src="getImage('about/02-01_ftoc.webp')">
            </section>
            <section>
              <h3><span>2.</span>製造指示等の作業を独自システムにより自動化</h3>
              <p>
                従来のオーダー家具の製造・販売には、膨大な時間と手間がかかります。  お客様のご要望を聞き、設計図を描き、必要な資材を考え、販売金額を計算し、
                ご要望が叶えられる内容になるまでこのプロセスを繰り返します。 全て一品ものとして設計されるため、製造においても職人がそれぞれの工程を細かく指示しなければなりません。<br>
                RASHIKUに掲載されている商品は、特許取得済みの独自技術により上記のプロセスが全て自動化されています。  その結果、人件費が大幅に削減され、
                低価格のオーダー家具となっており、自動化されているためさまざななミスも発生せず、高品質の商品となっております。
              </p>
              <img :src="getImage('about/02-02_automation.webp')">
            </section>
            <section id="cost_cut">
              <h3><span>3.</span>徹底的なコストカット</h3>
              <p>
                RASHIKU は、テレビCM等の広告を行っておりません。商品を梱包するダンボールにブランド名を印刷しないなど、可能な限り不要なコストを削減しています。<br>
                お客様に満足いただける商品を、満足いただける価格で提供させていただきます。
              </p>
              <div class="center_img">
                <img :src="getImage('about/02-03_cost.webp')">
              </div>
              <div class="detail_btn btn_pos_center" @click="routeCategory()">商品を選ぶ 〉〉</div>
            </section>
          </section>
          <section>
            <h2>従来の収納家具・オーダー家具との比較</h2>
            <p>
              既製品やオーダー家具、それぞれにメリットとデメリットがあります。<br>
              それらと比べて、RASHIKUの商品はバランスが良いオーダー家具となっております。<br>
              その理由は、RASHIKUが、サイズ・色柄種類のオーダー性を持ちながらも、さまざまな価格バリエーションの家具を購入できるサイトとして、運営されているからです。
            </p>
            <img :src="getImage('about/03_table.webp')">
            <div class="detail_btn btn_pos_center" @click="routeCategory()">商品を選ぶ 〉〉</div>
          </section>
          <section>
            <h2>お客様に選ばれる3つの理由</h2>
            <dd-reason />
          </section>
          <section>
            <h2>会員登録するとこんなに便利！</h2>
            <ul class="ul_user_register">
              <li>
                <h3>①会員限定価格での商品購入</h3>
                <img :src="getImage('about/04-01_special.webp')">
                <p>会員様限定の割引価格にて商品をご購入いただけるようになります。</p>
              </li>
              <li>
                <h3>②メールマガジンでお得な情報をお届け</h3>
                <img :src="getImage('about/04-02_mail.webp')">
                <p>クーポンや新商品、キャンペーンの情報などをいち早くお届けいたします。</p>
              </li>
              <li>
                <h3>③カスタマイズ情報の保存</h3>
                <img :src="getImage('about/04-03_save.webp')">
                <p>カスタマイズ中の商品情報を保存しておくことができます。</p>
              </li>
              <!-- <li v-show="false">
                <h3>④ご注文時の情報入力がスムーズに</h3>
                <img :src="getImage('about/04-04_smooth.webp')">
                <p>ここに説明文が入ります。</p>
              </li> -->
            </ul>
            <div class="detail_btn btn_pos_center" @click="route('DcSignUp')">会員登録はこちら 〉〉</div>
          </section>
          <!-- <section>
            <h2>＜お客様の状況毎＞ RASHIKUの使い方</h2>
            <p>
              ご自身での家具購入をご検討の場合、または業者様とリフォーム・リノベーションや新築をご検討の場合で、ご案内する内容が異なってまいります。以下から、お客様の状況をご選択ください。
            </p>
            <div class="procedure_with_img3">
              <div>
                <img :src="getImage('about/05-01_furniture.webp')">
              </div>
              <div>
                <img :src="getImage('about/05-02_renovation.webp')">
              </div>
              <div>
                <img :src="getImage('about/05-03_house.webp')">
              </div>
            </div>
            <section>
              <h3><span>1.</span>家具単体のご購入を検討される方</h3>
              <p>
                ご自身で採寸を行い、商品のカスタマイズを行う方へ向けて、ご購入ガイドページを用意しております。失敗せず、最適な商品をご購入いただくため、ぜひ以下ページをご覧ください。
              </p>
              <div class="detail_btn2 btn_pos_center" @click="route('DcPaymentGuide')">購入ガイドはこちら 〉〉</div>
              <section>
                <div>【 家具単体を購入されたお客様の設置例 】</div>
                <div class="procedure_with_img3">
                  <div>
                    <h3>吊戸棚（フロート収納）</h3>
                    <img :src="getImage('common/noimage.png')">
                    <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
                  </div>
                  <div>
                    <h3>食器棚（カップボード）</h3>
                    <img :src="getImage('common/noimage.png')">
                    <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
                  </div>
                  <div>
                    <h3>カウンター下収納</h3>
                    <img :src="getImage('common/noimage.png')">
                    <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
                  </div>
                  <div>
                    <h3>本棚・デスク</h3>
                    <img :src="getImage('common/noimage.png')">
                    <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
                  </div>
                  <div>
                    <h3>テレビボード</h3>
                    <img :src="getImage('common/noimage.png')">
                    <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
                  </div>
                  <div>
                    <h3>棚板</h3>
                    <img :src="getImage('common/noimage.png')">
                    <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
                  </div>
                </div>
              </section>
            </section>
            <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
          </section> -->
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {DC_PRPIC_ON, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DDReasonTable from '../components/top/DcSelectReasonTable'
import DDReason from '../components/top/DcSelectReason'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-menu': DDLeftMenu,
    'dd-reason-table': DDReasonTable,
    'dd-footer': DcFooter,
    'dd-reason': DDReason,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcAbout',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'about', key: 'dcAbout', title: 'RASHIKUについて', route: 'DcAbout2'}
      ],
      user: {}
    }
  },
  computed: {
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    routeCategory: function (params) {
      if (DC_PRPIC_ON === 1) {
        this.$router.push({
          name: 'DcPrpic',
          query: params
        })
      } else {
        this.$router.push({
          name: 'DcCategory',
          query: params
        })
      }
    }
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcAbout2.vue